import { useState, } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash, } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import img12 from "../assets/bgimg.png";
import logo from "../assets/logo.png";

import { register } from "../store/slices/auth";
import { useDispatch, useSelector } from "react-redux";

import "react-toastify/dist/ReactToastify.css";

export default function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, } = useSelector((state) => state.auth);

  const [organizationName, setOrganizationName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (field, value, setter) => {
    setter(value);

    let error = "";

    switch (field) {
      case "organizationName":
        if (!value.trim()) {
          error = "Please enter organization name";
        } else if (value.trim().length < 3) {
          error = "Organization name must be at least 3 characters";
        } else if (!/^[a-zA-Z0-9\s&.-]+$/.test(value)) {
          error =
            "Organization name can contain only letters, numbers, spaces, &, . and -";
        }
        break;

      case "name":
        if (!value.trim()) {
          error = "Please enter your name";
        } else if (value.trim().length < 2) {
          error = "Name must be at least 2 characters";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Name can contain only letters and spaces";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Please enter email";
        } else if (
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ) {
          error = "Please enter a valid email";
        }
        break;

      case "mobileNumber":
        if (!value.trim()) {
          error = "Please enter mobile number";
        } else if (!/^[6-9]\d{9}$/.test(value)) {
          error = "Please enter a valid 10-digit mobile number";
        }
        break;

      case "password":
        if (!value) {
          error = "Please enter password";
        } else if (/\s/.test(value)) {
          error = "Password cannot contain spaces";
        } else if (value.length < 8) {
          error = "Password must be at least 8 characters";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!organizationName.trim()) {
      newErrors.organizationName = "Please enter organization name";
    }

    if (!name.trim()) {
      newErrors.name = "Please enter your name";
    }

    if (!email.trim()) {
      newErrors.email = "Please enter email";
    }

    if (!mobileNumber.trim()) {
      newErrors.mobileNumber = "Please enter mobile number";
    }

    if (!password.trim()) {
      newErrors.password = "Please enter password";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const result = await dispatch(
        register({
          organizationName,
          name,
          email,
          mobileNumber,
          password,
        })
      );

      if (register.fulfilled.match(result)) {
        navigate("/verify-otp", {
          state: {
            email,
            phone: mobileNumber,
            type: "register",
          },
        });
      }
    }
  };



  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${img12})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.25)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={5} md={7} sm={10}>
              <Card className="shadow" style={{ borderRadius: "20px" }}>
                <Card.Body className="p-4">
                  <div className="text-center mb-3">
                    <img
                      src={logo}
                      alt="App Logo"
                      className="img-fluid"
                      style={{
                        maxWidth: "160px",
                        width: "100%",
                      }}
                    />
                  </div>

                  <h5 className="fw-bold mb-2 text-center purple-color">
                    Sign Up
                  </h5>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-1">
                      <Form.Label>Organization Name</Form.Label>
                      <Form.Control maxLength={30}
                        value={organizationName}
                        onChange={(e) =>
                          handleChange(
                            "organizationName",
                            e.target.value,
                            setOrganizationName
                          )
                        }
                        placeholder="Enter organization name"
                      />
                      {errors.organizationName && (
                        <small className="text-danger">{errors.organizationName}</small>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-1">
                      <Form.Label>Name</Form.Label>
                      <Form.Control maxLength={50}
                        value={name}
                        onChange={(e) =>
                          handleChange("name", e.target.value, setName)
                        }
                        placeholder="Enter your name"
                      />
                      {errors.name && (
                        <small className="text-danger">{errors.name}</small>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-1">
                      <Form.Label>Email</Form.Label>
                      <Form.Control maxLength={60}
                        type="email"
                        value={email}
                        onChange={(e) =>
                          handleChange("email", e.target.value, setEmail)
                        }
                        placeholder="Enter email"
                      />
                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-1">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        value={mobileNumber}
                        onChange={(e) =>
                          handleChange(
                            "mobileNumber",
                            e.target.value.replace(/\D/g, ""),
                            setMobileNumber
                          )
                        }
                        maxLength={10}
                        placeholder="Enter mobile number"
                      />
                      {errors.mobileNumber && (
                        <small className="text-danger">{errors.mobileNumber}</small>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-2">
                      <Form.Label>Password</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={(e) =>
                            handleChange(
                              "password",
                              e.target.value,
                              setPassword
                            )
                          } maxLength={25}
                          placeholder="Enter password"
                        />

                        <span
                          className="position-absolute top-50 end-0 translate-middle-y me-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                      </div>

                      {errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </Form.Group>
                    <div
                      className="text-left  mb-3"
                      style={{ fontSize: "13px", color: "#6c757d" }}
                    >
                      By clicking <strong>Register</strong>, I accept the{" "}
                      <a
                        href="https://dwellium.in/terms-and-conditions.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none fw-semibold"
                      >
                        Terms and Conditions
                      </a>
                      .
                    </div>

                    <Button
                      disabled={loading}
                      type="submit"
                      className="w-100"
                      style={{
                        backgroundColor: "#1e0959",
                        border: "none",
                        borderRadius: "30px",
                        padding: "10px",
                      }}
                    >
                      {loading ? "Registering..." : "Register"}
                    </Button>

                    <div className="text-center mt-3">
                      Already have an account?{" "}
                      <Link
                        to="/login"
                        className="text-decoration-none fw-semibold purple-color"
                      >
                        Login
                      </Link>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
